import React from 'react';
import "../../styles/global-hero.css";

const Hero = () => {
    return (
        <div className="global-hero">
            <div className="container text-center">
                <h1>Important Emails</h1>
                <p>Home &gt; Important Emails</p>
            </div>
        </div>
    )
}

export default Hero;